"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = __importStar(require("prop-types"));
var React = __importStar(require("react"));
var removeAccents_1 = require("sportnet-utilities/lib/removeAccents");
var getProp_1 = __importDefault(require("sportnet-utilities/lib/getProp"));
var InputAutocomplete_1 = __importDefault(require("../InputAutocomplete"));
var redux_form_1 = __importDefault(require("../InputAutocomplete/redux-form"));
var AutocompleteSelect = /** @class */ (function (_super) {
    __extends(AutocompleteSelect, _super);
    function AutocompleteSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        _this.setValue = function (props) {
            var _a, _b, _c;
            if (props === void 0) { props = _this.props; }
            var items = props.items, name = props.name, value = props.value;
            if (value) {
                var item = items.find(function (i) { return i.value === value; });
                if (item) {
                    _this.setState({
                        autocomplete: __assign(__assign({}, _this.state.autocomplete), (_a = {}, _a[name] = item.label, _a)),
                    });
                }
                else {
                    _this.setState({
                        autocomplete: __assign(__assign({}, _this.state.autocomplete), (_b = {}, _b[name] = value, _b)),
                    });
                }
            }
            else {
                _this.setState({
                    autocomplete: __assign(__assign({}, _this.state.autocomplete), (_c = {}, _c[name] = value, _c)),
                });
            }
        };
        console.warn('AutocompleteSelect is DEPRECATED. Use TheSelect instead.');
        return _this;
    }
    AutocompleteSelect.prototype.componentDidMount = function () {
        this.setValue();
    };
    /**
     * Soon to be deprecated in favor of TheSelect
     */
    AutocompleteSelect.prototype.UNSAFE_componentWillReceiveProps = function (nextProps, nextState) {
        if (this.props.value !== nextProps.value ||
            this.props.items.length !== nextProps.items.length ||
            !getProp_1.default(nextState, ['autocomplete', nextProps.name])) {
            this.setValue(nextProps);
        }
    };
    AutocompleteSelect.prototype.render = function () {
        var _this = this;
        var _a = this.props, name = _a.name, disabled = _a.disabled, items = _a.items, onChange = _a.onChange, restProps = __rest(_a, ["name", "disabled", "items", "onChange"]);
        var Component = this.props.isRedux
            ? redux_form_1.default
            : InputAutocomplete_1.default;
        return (React.createElement(Component, __assign({}, restProps, { name: name, value: getProp_1.default(this.state, ['autocomplete', name], ''), disabled: disabled, submitAllowed: false, onSelectItem: function (item) {
                var _a;
                _this.setState({
                    autocomplete: __assign(__assign({}, _this.state.autocomplete), (_a = {}, _a[name] = item.label, _a)),
                }, function () {
                    onChange(item.value);
                });
            }, onChange: function (value) {
                var _a;
                _this.setState({
                    autocomplete: __assign(__assign({}, _this.state.autocomplete), (_a = {}, _a[name] = value, _a)),
                });
            }, items: items.reduce(function (acc, i) {
                var value = getProp_1.default(_this.state, ['autocomplete', name], '');
                var regex = new RegExp(removeAccents_1.removeAccents(value));
                if (!value || removeAccents_1.removeAccents(i.label).match(regex)) {
                    return __spreadArrays(acc, [
                        {
                            label: i.label,
                            value: i.value,
                        },
                    ]);
                }
                return acc;
            }, []), getItemLabel: function (e) { return e.label; } })));
    };
    AutocompleteSelect.propTypes = {
        onChange: PropTypes.func,
        name: PropTypes.string.isRequired,
        items: PropTypes.arrayOf(PropTypes.shape({
            label: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
                .isRequired,
            value: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
                PropTypes.bool,
            ]).isRequired,
        })).isRequired,
        disabled: PropTypes.bool,
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
            PropTypes.bool,
        ]),
        isRedux: PropTypes.bool,
    };
    AutocompleteSelect.defaultProps = {
        disabled: false,
        value: null,
        onChange: function () { },
        isRedux: false,
    };
    return AutocompleteSelect;
}(React.PureComponent));
exports.default = AutocompleteSelect;
